/**
 * Extracts
 * @param {array} contestData - Arrays of contests
 */

import flattenContestRounds from '../../../utils/flattenContestRounds';
import moment from 'moment';

class contestActiveStates {
  get (contests) {
    let contestsActiveId
    let roundActiveId
    let roundActiveUpdateDate
    let isSelectedRoundActive
    // It can be true that a contest is active without any rounds within set to active
    // This can be true when the other
    // check we have at least 1 active round
    const states = {
      contestsWithActiveStates: [],
      contestsWithoutActiveStatesWithActiveRounds: {
        contestExternalId: null,
        roundExternalId: null,
        lastRoundUpdate: null
      },
      noActiveContestsOrRounds: {
        contestExternalId: null,
        roundExternalId: null,
        lastRoundUpdate: null
      }
    }
    for (let i = 0; i < contests.length; ++i) {
      const contest = contests[i]
      if (!contest.rounds) {
        contest.rounds = flattenContestRounds(contest);
      }
      if (this.stateActive(contest)) {
        const currentActiveContest = {
          contestExternalId: contest.externalId,
          roundExternalId: null,
          lastRoundUpdate: null
        }
        // check for an active round
        for (let k = 0; k < contest.rounds.length; ++k) {
          const round = contest.rounds[k]
          if (this.stateActive(round) &&
            (!roundActiveUpdateDate || moment(round.updated).isAfter(roundActiveUpdateDate) || !isSelectedRoundActive)
          ) {
            contestsActiveId = contest.externalId
            roundActiveId = round.externalId
            roundActiveUpdateDate = round.updated
            currentActiveContest.lastRoundUpdate = round.updated
            isSelectedRoundActive = true
          } else {
            const roundUpdateDate = new Date(round.updated)
            if (!roundActiveUpdateDate || (roundActiveUpdateDate <= roundUpdateDate)
            ) {
              currentActiveContest.roundExternalId = round.externalId
              roundActiveUpdateDate = roundUpdateDate
              isSelectedRoundActive = false
            }
          }
        }
        states.contestsWithActiveStates.push(currentActiveContest)
      } else {
        const stateKey = (contest.rounds.some(this.stateActive)) ?
          'contestsWithoutActiveStatesWithActiveRounds' :
          'noActiveContestsOrRounds'
        contest.rounds
          .filter((round) => this.stateActive(round) && round.updated)
          .forEach((round) => {
            if (
              !roundActiveUpdateDate ||
              moment(round.updated).isAfter(roundActiveUpdateDate) ||
              (moment(round.updated).isBefore(roundActiveUpdateDate) && !isSelectedRoundActive)
            ) {
              contestsActiveId = contest.externalId
              roundActiveId = round.externalId
              states[stateKey].contestExternalId = contest.externalId
              states[stateKey].roundExternalId = round.externalId
              states[stateKey].lastRoundUpdate = round.updated
              roundActiveUpdateDate = round.updated
            }
          })
      }
    }
    // no contest with active round found
    if (!contestsActiveId) {
      // Active contests found, extract the latest round
      if (states.contestsWithActiveStates.length !== 0) {
        let contestsWithActiveStatesLastUpdate
        states.contestsWithActiveStates.forEach((contestsWithActiveState) => {
          if (!contestsWithActiveStatesLastUpdate ||
            (contestsWithActiveState.lastRoundUpdate > contestsWithActiveStatesLastUpdate)
          ) {
            contestsActiveId = contestsWithActiveState.contestExternalId
            roundActiveId = contestsWithActiveState.roundExternalId
            contestsWithActiveStatesLastUpdate = contestsWithActiveState.lastRoundUpdate
          }
        })
      } else {
        const stateKey = (states.contestsWithoutActiveStatesWithActiveRounds.contestExternalId) ?
          'contestsWithoutActiveStatesWithActiveRounds' :
          'noActiveContestsOrRounds'
        contestsActiveId = states[stateKey].contestExternalId
        roundActiveId = states[stateKey].roundExternalId
      }
    }
    return {
      contestsActiveId,
      roundActiveId
    }
  }

  stateActive (item) {
    return item.state && item.state.toLowerCase() === 'active'
  }
}

export default new contestActiveStates()



// WEBPACK FOOTER //
// ./src/views/Home/updater/contestActiveStates.js